export enum RoleEnum {
  ROLE_USER = 'User',
  ROLE_FRIEND = 'Friend',
  ROLE_VIP = 'VIP'
}
